import React, { useState } from 'react';
import { StatOptions } from 'fs';
import {IDNameDescriptionItem,IDNameDescriptionDictionary} from '../models/Site'
import './_IDNameDescriptionItemSelect.css'




type Props = {
    Value:any|null;
    Options:IDNameDescriptionDictionary;
    Id:string;
    OnChange: any;
    OnSelect?: any;
    Disabled?: boolean;
    readonly?: boolean
    style?: any;
  };

  
  

export class IDNameDescriptionItemSelect extends React.Component<Props>
{
    
    constructor(props:any) {
        super(props); 
        this.handleChange.bind(this);
              
      }
      componentDidMount(){

        const options:IDNameDescriptionItem[] = [];
      }

      handleChange = (event:any) => {
        var selectedValue=event.currentTarget.selectedOptions[0].value;
        this.props.OnChange(this.props.Id,selectedValue);
      }

      handleSelect= (event:any) => {
        var selectedValue=event.currentTarget.selectedOptions[0].value;
        this.props.OnSelect(this.props.Id,selectedValue);
      }
      
      
    render() {
      return (   
        <select value={this.props.Value}
        id={this.props.Id}
        key={this.props.Id}
        onChange={this.handleChange}
        onSelect={this.handleSelect}
        disabled={this.props.Disabled}
        style={this.props.style}
        >
          {
            Object.entries(this.props.Options)
              .map( ([key, value]) => <option value={value.id} key={value.id}>{value.description}</option>)
          }
            
        </select>
        
      );
    }
  }
